module.exports = __webpack_public_path__ + "img/logo.8c074fa7.png";